<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <div class="modal-header">
      <h4 class="modal-heading" translate>change-password-modal.title</h4>
      <img src="assets/icon/primary-close.svg" (click)="closeDialog(false)" class="modal-close" width="32" height="32"
        alt="Close Icon">
    </div>
    <div class="modal-body">
      <div class="modal-content" *ngIf="step === 1">
        <p class="smaller text-content" translate>change-password-modal.enter-current-password</p>

        <form [formGroup]="currentPasswordForm">
          <label class="outlined-label-input" [class.input-error]="showCurrentError">
            <input [type]="showCurrentPassword ? 'text' : 'password'" formControlName="password"
              (input)="showCurrentError = false" placeholder=" ">
            <span translate>change-password-modal.current-password<span class="star">*</span></span>
            <img class="eye" [src]="showCurrentPassword ? 'assets/icon/hide-eye.svg' : 'assets/icon/show-eye.svg'"
              (click)="preventInputFocus($event); showCurrentPassword = !showCurrentPassword"
              (mousedown)="preventInputFocus($event)" *ngIf="currentPasswordForm.controls['password'].value"
              [attr.alt]="'change-password-modal.alt-eye' | translate" height="16" width="16">
          </label>

          <p *ngIf="currentPasswordForm.controls['password'].touched && currentPasswordForm.controls['password'].hasError('required')"
            class="validation-message" translate>
            change-password-modal.current-password-required
          </p>

          <p *ngIf="showCurrentError" class="validation-message" translate>
            change-password-modal.invalid-password
          </p>
        </form>
      </div>

      <div class="modal-content" *ngIf="step === 2">
        <p class="smaller text-content" translate>change-password-modal.enter-new-password</p>

        <form [formGroup]="newPasswordForm">
          <label class="outlined-label-input second">
            <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" placeholder=" "
              (focus)="isNewPassFocused = true" (blur)="isNewPassFocused = false">
            <span translate>change-password-modal.new-password <span class="star">*</span></span>
            <img class="eye" [src]="showNewPassword ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
              (click)="preventInputFocus($event); showNewPassword = !showNewPassword"
              (mousedown)="preventInputFocus($event)" *ngIf="newPasswordForm.controls['newPassword'].value"
              alt="eye icon" height="16" width="16">
          </label>

          <p *ngIf="newPasswordForm.controls['newPassword'].touched && newPasswordForm.controls['newPassword'].hasError('required')"
            class="validation-message" translate>
            change-password-modal.new-password-required
          </p>

          <div class="password-banner" *ngIf="isNewPassFocused">
            <div class="banner-box">
              <img alt="info" src="assets/icon/twisted-primary-info.svg" height="16" width="16">
              <div class="banner-note">
                <p class="caption" translate>change-password-modal.passwords-must-have</p>
                <ul>
                  <li>
                    <img *ngIf="!newPassword?.value" src="assets/icon/green-circle.svg" alt="status icon" height="16" width="16">
                    <img *ngIf="newPassword?.value"
                      [src]="!newPassword?.hasError('length') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption" translate>change-password-modal.characters-6-12</p>
                  </li>
                  <li>
                    <img *ngIf="!newPassword?.value" src="assets/icon/green-circle.svg" alt="status icon" height="16" width="16">
                    <img *ngIf="newPassword?.value"
                      [src]="!newPassword?.hasError('lowercase') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption" translate>change-password-modal.one-small-letter</p>
                  </li>
                  <li>
                    <img *ngIf="!newPassword?.value" src="assets/icon/green-circle.svg" alt="status icon" height="16" width="16">
                    <img *ngIf="newPassword?.value"
                      [src]="!newPassword?.hasError('uppercase') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption" translate>change-password-modal.one-capital-letter</p>
                  </li>
                  <li class="last">
                    <img *ngIf="!newPassword?.value" src="assets/icon/green-circle.svg" alt="status icon" height="16" width="16">
                    <img *ngIf="newPassword?.value"
                      [src]="!newPassword?.hasError('digit') ? 'assets/icon/success-check.svg' : 'assets/icon/red-x.svg'"
                      alt="status icon" height="16" width="16">
                    <p class="caption" translate>change-password-modal.one-digit</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <label class="outlined-label-input second">
            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmNewPassword"
              placeholder=" ">
            <span translate>change-password-modal.confirm-password <span class="star">*</span></span>
            <img class="eye" [src]="showConfirmPassword ? 'assets/icon/hide-eye.svg' : 'assets/icon/show-eye.svg'"
              (click)="preventInputFocus($event); showConfirmPassword = !showConfirmPassword"
              (mousedown)="preventInputFocus($event)" *ngIf="newPasswordForm.controls['confirmNewPassword'].value"
              [attr.alt]="'change-password-modal.alt-eye' | translate" height="16" width="16">
          </label>

          <p *ngIf="newPasswordForm.controls['confirmNewPassword'].touched && newPasswordForm.controls['confirmNewPassword'].hasError('required')"
            class="validation-message" translate>
            change-password-modal.confirm-password-required
          </p>
          <p *ngIf="passwordMismatch"
            class="validation-message" translate>
            change-password-modal.passwords-no-match
          </p>
        </form>
      </div>

      <div class="modal-actions">
        <button *ngIf="step === 1" class="button primary" (click)="submitCurrentPassword()" translate>
          change-password-modal.submit
        </button>
        <button *ngIf="step === 2" class="button primary" (click)="updatePassword()" translate>
          change-password-modal.save
        </button>
        <button class="button tertiary" (click)="closeDialog(false)" translate>
          change-password-modal.cancel
        </button>
      </div>
    </div>
  </div>
</div>
